import React from "react";
import "../styles/platinum.css";

export default function Platinum() {
  return (
    <div className="page">
      {/* HERO */}
      <section className="hero hero--platinum">
        <div className="hero__overlay" />

        <div className="container hero__content hero__content--center">
          <span className="hero__eyebrow">Exclusive Membership</span>

          <h1 className="hero__title">Platinum Club</h1>
          <h2 className="hero__headline">A New Standard of Luxury</h2>

          <p className="hero__subtitle">
            Our most exclusive membership experience is almost here.
          </p>

        <br/>
          <div className="hero__badge">Coming Soon</div>
        </div>
      </section>
    </div>
  );
}
